import { render, staticRenderFns } from "./VariantConfig.vue?vue&type=template&id=55a44a20&scoped=true&"
import script from "./VariantConfig.vue?vue&type=script&lang=js&"
export * from "./VariantConfig.vue?vue&type=script&lang=js&"
import style0 from "./VariantConfig.vue?vue&type=style&index=0&id=55a44a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a44a20",
  null
  
)

export default component.exports